import { render, staticRenderFns } from "./CompaniesCard.vue?vue&type=template&id=0fbb27e1&"
import script from "./CompaniesCard.vue?vue&type=script&lang=js&"
export * from "./CompaniesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports